import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { ErrorTypeEnum } from '../../core/models/enums/error-type.enum';
import { AppConstants } from '../../app.constants';

import { UIService } from '../../core/services/utils/ui.service';
import { ScreensStateService } from '../../core/services/screen-state/screens-state.service';
import { MonitorHub } from '../../shared-module/hubs/monitor.hub';
import { TagsStateService } from '../../core/services/screen-state/tags-state.service';
import { PlaylistStateService } from '../../core/services/screen-state/playlists-state.service';

@Component({
  templateUrl: './dashboard-outlet.component.html',
  styleUrls: ['./dashboard-outlet.component.scss'],
  providers: [TagsStateService, PlaylistStateService]
})
export class DashboardOutletComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private readonly monitorHub: MonitorHub,
    private readonly screenState: ScreensStateService,
    private readonly uiService: UIService,
    private readonly toastsService: ToastrService
  ) {
    this.subscriptions.push(
      this.monitorHub.Disconnected.subscribe(() => {
        this.uiService.showGreyout();
      })
    );

    this.subscriptions.push(
      this.monitorHub.desktopMachineErrorOccured.subscribe(data => {
        if (data.Message !== AppConstants.MAWI_SERVER_IS_NO_RUNNING_ERROR_MESSAGE) {
          this.toastsService.error(
            data.Message,
            `Error on machine: ${
              data.ErrorType === ErrorTypeEnum.ServiceError
                ? data.PhysicalAddress
                : data.MachineTitle
            }`,
            {
              toastClass: 'client-machine-error-toastr'
            }
          );
        } else {
          this.screenState.locationWithNotRunningService.push(data.PhysicalAddress);
        }
      })
    );

    this.subscriptions.push(
      this.monitorHub.Connected.subscribe(dat => {
        if (dat) {
          uiService.hideGreyout();
        } else {
          uiService.showGreyout();
        }
      })
    );
  }

  ngOnInit(): void {
    this.screenState.initMonitors();
  }

  ngOnDestroy() {
    this.screenState.destroy();
    if (this.monitorHub && this.monitorHub.Connected) {
      this.monitorHub.disconnect();
    }

    this.subscriptions.forEach(x => x.unsubscribe());
  }
}
